import { Button, Icon } from "@Rolec-Services/rolec-ui";
import { useTranslation } from "react-i18next";
import { cn } from "~/utils/utils";

export type ActionsProps = {
  step: number;
  numSteps: number;
  nextStep: () => void;
  prevStep: () => void;
};

export function Actions({ step, nextStep, prevStep, numSteps }: ActionsProps) {
  const { t } = useTranslation();
  return (
    <div
      className={cn("flex w-full justify-between", {
        "justify-center": step === 0,
      })}
    >
      {step > 1 && (
        <Button
          type="button"
          className="w-32"
          variant="text"
          onClick={prevStep}
          disabled={step === 0}
        >
          <Icon icon="ArrowLeft" />
          {t("Previous")}
        </Button>
      )}
      {step != 1 && (
        <Button
          variant={step == 0 ? "ev-green-primary" : "primary"}
          className="w-32"
          onClick={nextStep}
        >
          <ButtonContent step={step} numSteps={numSteps} />
        </Button>
      )}
    </div>
  );
}

type ButtonContentProps = Pick<ActionsProps, "step" | "numSteps">;

function ButtonContent({ step, numSteps }: ButtonContentProps) {
  const { t } = useTranslation();
  switch (step) {
    case 0:
      return t("Start");
    case numSteps - 1:
      return t("Submit");
    default:
      return (
        <>
          {t("Confirm")}
          <Icon icon="ArrowRight" />
        </>
      );
  }
}
